export default function getPlacementLabel(
    controller,
    placementCode,
    i18n,
    fallbackName,
) {
    const placement = controller.findPlacement(placementCode);
    let name = placement ? placement.name : fallbackName;

    if (name) {
        const key = `${controller.blueprint.custom['t-master-product']}-${name}`;

        if (i18n.te(key) || i18n.te(key, i18n.fallbackLocale)) {
            name = i18n.t(key);
        }
    }

    return name;
}
